import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
        return state.items.map(bridge => ({
            value: bridge.id,
            label: bridge.name,
        }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/bridge/admin/account', { params })

      if (!data.success) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/bridge/admin/account/${id}`, params)

      return data
    },
    async update(_, params) {
      const { data } = await axios.put(`v1/bridge/admin/account/api/update`, params)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
